// Constants used only by the Home feature.

// DefaultView display constants
export const DEFAULT_VIEW_TEXT = {
  DEFAULT_TITLE: "Amazon Meetings Assistant",
  STOPPED_TITLE: "Amazon Meetings Assistant stopped",
  STOPPED_SUBTITLE: "You'll receive a meeting summary when it's ready.",
  ATTENDEE_SUBTITLE: "Meeting organizers can turn on meeting summary.",
};

// Shown as a toast when enabling/disabling an agent (organizer toggle) fails.
export const AGENT_TOGGLE_ERROR_MESSAGE =
  "Something went wrong while updating the agent. Try again in a moment.";

// Scheduled-agent auto-activation, Case 1 (scheduled list fetch failed) and Case 3 (every
// scheduled agent failed to activate): nothing got activated, so both use this message.
// The Case-2 partial-failure message builder (scheduledAgentsPartialErrorMessage) lives in
// utils/AgentDisplayUtils.js
export const SCHEDULED_AGENTS_ALL_INACTIVE_MESSAGE =
  "All agents are inactive. Toggle them on in Settings.";
